<div class="link-network">
    <div class="container">
        <p class="link-network__title">Social</p>
        <div class="link-network__icon">
            <a *ngFor="let item of socialLinks" class="link-network__icon_link" href="{{ item.url }}">
                <img class="link-network__icon_image" [src]="'item.icon'" />
            </a>
        </div>
    </div>
</div>
